let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("leALi")).then(() => parcelRequire('7r0z6'));